import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function TabletIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M18 1H6C4.3457 1 3 2.3457 3 4V20C3 21.6543 4.3457 23 6 23H18C19.6543 23 21 21.6543 21 20V4C21 2.3457 19.6543 1 18 1ZM19 20C19 20.5518 18.5513 21 18 21H6C5.44873 21 5 20.5518 5 20V4C5 3.44824 5.44873 3 6 3H18C18.5513 3 19 3.44824 19 4V20Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M12 20C12.8284 20 13.5 19.3284 13.5 18.5C13.5 17.6716 12.8284 17 12 17C11.1716 17 10.5 17.6716 10.5 18.5C10.5 19.3284 11.1716 20 12 20Z",
    fill: "currentColor"
  }));
}